module.exports = __webpack_public_path__ + "img/logo.small.f0848338.png";